import Nullstack from 'nullstack';
export default function IconFileBroken({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-file-broken",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), "   ", Nullstack.element("path", {
    d: "M5 7v-2a2 2 0 0 1 2 -2h7l5 5v2"
  }), "   ", Nullstack.element("path", {
    d: "M19 19a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2"
  }), "   ", Nullstack.element("path", {
    d: "M5 16h.01"
  }), "   ", Nullstack.element("path", {
    d: "M5 13h.01"
  }), "   ", Nullstack.element("path", {
    d: "M5 10h.01"
  }), "   ", Nullstack.element("path", {
    d: "M19 13h.01"
  }), "   ", Nullstack.element("path", {
    d: "M19 16h.01"
  }), " ");
}